import * as t from 'io-ts';

import { TMethod } from '../src/method';
import { PeriodNameEnum } from '../../../src/modules/earning/model';

import { Earning } from './w4d-earnings-types';

type Params = {
  get: TMethod;
  apiHost: string;
};

const w4dEarningsRemoteAPI = ({ apiHost, get }: Params) => ({
  readEarnings: {
    path: ({ periodName }: any) => `${apiHost}/v6/drivers/earnings?period_name=${periodName}`,
    pathParams: t.type({
      periodName: t.keyof(PeriodNameEnum),
    }),
    method: get,
    response: t.type({
      earnings: t.array(Earning),
      from: t.string,
      to: t.string,
    }),
  },
});

export { w4dEarningsRemoteAPI };
